import {
  SET_ACCOUNTING_PAGE_COUNT,
  SET_CARD_REQUESTS_COUNT,
  SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT,
  SET_READY_TO_PAY_BILLS_COUNT,
  SET_RECEIPTS_COUNT,
  SET_RECURRING_SPEND_SUGGESTIONS_COUNT,
  SET_REIMBURSABLE_EXPENSES_COUNT,
  SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT,
  SET_SIDEBAR_TRANSACTIONS_COUNT,
  SidebarCountersAction
} from '../actions';

interface ISidebarCountersState {
  transactionsCount: number | null;
  reimbursableExpensesCount: number | null;
  cardRequestsCount: number | null;
  readyToPayBillsCount: number | null;
  personalTransactionsCount: number | null;
  personalReimbursableExpensesCount: number | null;
  receiptsCount: number | null;
  recurringSpendSuggestionsCount: number | null;
  accountingPageCount: number | null;
}

export const defaultState: ISidebarCountersState = {
  transactionsCount: null,
  reimbursableExpensesCount: null,
  cardRequestsCount: null,
  readyToPayBillsCount: null,
  personalTransactionsCount: null,
  personalReimbursableExpensesCount: null,
  receiptsCount: null,
  recurringSpendSuggestionsCount: null,
  accountingPageCount: null
};

export const sidebarCountersReducer = (state = defaultState, action: SidebarCountersAction) => {
  switch (action.type) {
    case SET_SIDEBAR_TRANSACTIONS_COUNT:
      return { ...state, transactionsCount: action.payload };
    case SET_CARD_REQUESTS_COUNT:
      return { ...state, cardRequestsCount: action.payload };
    case SET_REIMBURSABLE_EXPENSES_COUNT:
      return { ...state, reimbursableExpensesCount: action.payload };
    case SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT:
      return { ...state, personalReimbursableExpensesCount: action.payload };
    case SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT:
      return { ...state, personalTransactionsCount: action.payload };
    case SET_RECEIPTS_COUNT:
      return { ...state, receiptsCount: action.payload };
    case SET_READY_TO_PAY_BILLS_COUNT:
      return { ...state, readyToPayBillsCount: action.payload };
    case SET_RECURRING_SPEND_SUGGESTIONS_COUNT:
      return { ...state, recurringSpendSuggestionsCount: action.payload };
    case SET_ACCOUNTING_PAGE_COUNT:
      return { ...state, accountingPageCount: action.payload };
    default:
      return state;
  }
};
